<template>
  <q-btn
    dense
    no-caps
    flat
    size="sm"
  >
    <span
      class="dot square"
      :style="{'background-color': foreColor}"
    />
    <q-tooltip>
      Background & Text Colour
    </q-tooltip>
    <q-popup-proxy ref="proxy">
      <q-card>
        <q-list separator>
          <q-item class="q-py-md">
            <q-item-section
              side
              top
            >
              <q-icon name="format_paint" />
            </q-item-section>
            <q-item-section
              side
              top
              style="width: 90px;"
            >
              Text
            </q-item-section>
            <q-item-section>
              <color-picker
                v-model="foreColor"
                :disable="disable"
                hide-toolbar
                @update:model-value="setColor('foreColor', foreColor)"
              />
            </q-item-section>
          </q-item>
          <q-item class="q-py-md">
            <q-item-section
              side
              top
            >
              <q-icon name="highlight" />
            </q-item-section>
            <q-item-section
              side
              top
              style="width: 90px;"
            >
              Background
            </q-item-section>
            <q-item-section>
              <color-picker
                v-model="highlight"
                :disable="disable"
                hide-toolbar
                @update:model-value="setColor('backColor', highlight)"
              />
            </q-item-section>
          </q-item>
        </q-list>
      </q-card>
    </q-popup-proxy>
  </q-btn>
</template>

<script>
export default {
  props: {
    disable: {
      type: Boolean,
      required: true
    }
  },
  emits: ['run'],
  data () {
    return {
      foreColor: '#000000',
      highlight: '#ffffff'
    }
  },
  methods: {
    setColor (type, color) {
      this.$refs.proxy.hide()
      this.$emit('run', type, color)
    }
  }
}
</script>
